import { render, staticRenderFns } from "./indexCompare.vue?vue&type=template&id=d86def54&scoped=true"
import script from "./indexCompare.vue?vue&type=script&lang=js"
export * from "./indexCompare.vue?vue&type=script&lang=js"
import style0 from "./indexCompare.vue?vue&type=style&index=0&id=d86def54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d86def54",
  null
  
)

export default component.exports